export default "__VITE_ASSET__BZkNMTyy__"